export const customThemeWithBreakPoints = {
  breakpoints: ['20.1rem', '34rem', '49rem', '65rem', '100rem'],
};
